import CommonDataIo from "@/pcomponents/common/content/chat/data_io";
function DataIo(props: any) {
  let myProps = {
    data_io_ref: null,
    roomInfoArrRef: null,
    setRoomInfoArr: (inData: any) => { },
    student_info_arr_ref: null,
    set_student_info_arr: (inData: any) => { },
    listOptRef: null,
    ...props
  };
  const on_receive = (msg: any) => {
    if (msg.detail == "update" && msg.todo_dailyc_arr && msg.todo_dailyc_arr.length > 0
      && msg.sort == "todo_dailyc_arr"
      && myProps.listOptRef.current
      && myProps.listOptRef.current.s_select_date == msg.select_date) {

      let change_student_info_arr = [...myProps.student_info_arr_ref.current];
      for (let stu_i = 0; stu_i < change_student_info_arr.length; stu_i++) {
        let stu_info = change_student_info_arr[stu_i];
        if (stu_info.todo_dailyc_arr == undefined) {
          stu_info.todo_dailyc_arr = [];
        }
        for (let j = 0; j < msg.todo_dailyc_arr.length; j++) {
          let change_todo_dailyc = msg.todo_dailyc_arr[j];
          let is_exist = false;
          for (let c_i = 0; c_i < stu_info.todo_dailyc_arr.length; c_i++) {
            let todo_dailyc = stu_info.todo_dailyc_arr[c_i];
            //있으면 덮어쓰기
            if (todo_dailyc.a_mcomp_seq == change_todo_dailyc.a_mcomp_seq
              && todo_dailyc.a_date == change_todo_dailyc.a_date
              && todo_dailyc.a_subject == change_todo_dailyc.a_subject
              && todo_dailyc.a_stu_seq == change_todo_dailyc.a_stu_seq
            ) {
              is_exist = true;
              stu_info.todo_dailyc_arr[c_i] = change_todo_dailyc;
            }
          }
          if (is_exist == false) {
            //없다면 추가
            if (stu_info.a_mcomp_seq == change_todo_dailyc.a_mcomp_seq
              && stu_info.a_seq == change_todo_dailyc.a_stu_seq) {
              stu_info.todo_dailyc_arr.push(change_todo_dailyc);
            }
          }
        }
      }
      myProps.set_student_info_arr(change_student_info_arr);
    }

    if (msg.detail == "delete" && msg.todo_dailyc_arr && msg.todo_dailyc_arr.length > 0
      && msg.sort == "todo_dailyc_arr"
      && myProps.listOptRef.current
      && myProps.listOptRef.current.s_select_date == msg.select_date) {

      let change_student_info_arr = [...myProps.student_info_arr_ref.current];

      for (let stu_i = 0; stu_i < change_student_info_arr.length; stu_i++) {
        let stu_info = change_student_info_arr[stu_i];
        if (stu_info.todo_dailyc_arr == undefined) {
          stu_info.todo_dailyc_arr = [];
        }
        let new_todo_dailyc_arr: any = [];
        for (let c_i = 0; c_i < stu_info.todo_dailyc_arr.length; c_i++) {
          let todo_dailyc = stu_info.todo_dailyc_arr[c_i];
          //매칭되는것 제외
          let is_exist = false;
          for (let j = 0; j < msg.todo_dailyc_arr.length; j++) {
            let change_todo_dailyc = msg.todo_dailyc_arr[j];
            if (todo_dailyc.a_mcomp_seq == change_todo_dailyc.a_mcomp_seq
              && todo_dailyc.a_date == change_todo_dailyc.a_date
              && todo_dailyc.a_subject == change_todo_dailyc.a_subject
              && todo_dailyc.a_stu_seq == change_todo_dailyc.a_stu_seq
            ) {
              is_exist = true;
              break;
            }
          }
          if (is_exist == false) {
            new_todo_dailyc_arr.push(todo_dailyc);
          }
        }
        stu_info.todo_dailyc_arr = new_todo_dailyc_arr;
      }
      myProps.set_student_info_arr(change_student_info_arr);
    }

    if (msg.detail == "update" && msg.desk_use_arr && msg.desk_use_arr.length > 0
      && msg.sort == "desk_use_arr"
      && myProps.listOptRef.current
      && myProps.listOptRef.current.s_select_date == msg.select_date) {

      let change_roomInfoArr = [...myProps.roomInfoArrRef.current];

      for (let room_i = 0; room_i < change_roomInfoArr.length; room_i++) {
        let room_info = change_roomInfoArr[room_i];
        if (room_info.desku_arr == undefined) {
          room_info.desku_arr = [];
        }

        for (let j = 0; j < msg.desk_use_arr.length; j++) {
          let change_desk_use = msg.desk_use_arr[j];
          let is_exist = false;
          for (let desk_i = 0; desk_i < room_info.desku_arr.length; desk_i++) {
            let desk_use_info = room_info.desku_arr[desk_i];
            //있으면 덮어쓰기

            if (desk_use_info.a_mcomp_seq == change_desk_use.a_mcomp_seq
              && desk_use_info.a_ymd == change_desk_use.a_ymd
              && desk_use_info.a_seq == change_desk_use.a_seq
            ) {
              is_exist = true;
              room_info.desku_arr[desk_i] = change_desk_use;
            }
          }
          //없다면추가
          if (is_exist == false) {
            if (room_info.a_mcomp_seq == change_desk_use.a_mcomp_seq
              && room_info.a_seq == change_desk_use.a_room_seq
            ) {
              room_info.desku_arr.push(change_desk_use);
            }
          }
        }
      }
      myProps.setRoomInfoArr(change_roomInfoArr);
    }

    if (msg.detail == "delete" && msg.desk_use_arr && msg.desk_use_arr.length > 0
      && msg.sort == "desk_use_arr"
      && myProps.listOptRef.current
      && myProps.listOptRef.current.s_select_date == msg.select_date) {

      let change_roomInfoArr = [...myProps.roomInfoArrRef.current];

      for (let room_i = 0; room_i < change_roomInfoArr.length; room_i++) {
        let room_info = change_roomInfoArr[room_i];
        if (room_info.desku_arr == undefined) {
          room_info.desku_arr = [];
        }
        let new_desku_arr = [];
        for (let desk_i = 0; desk_i < room_info.desku_arr.length; desk_i++) {
          let desk_use_info = room_info.desku_arr[desk_i];
          //매칭되는것 제외
          let is_exist = false;
          for (let j = 0; j < msg.desk_use_arr.length; j++) {
            let change_desk_use = msg.desk_use_arr[j];
            if (desk_use_info.a_mcomp_seq == change_desk_use.a_mcomp_seq
              && desk_use_info.a_ymd == change_desk_use.a_ymd
              && desk_use_info.a_seq == change_desk_use.a_seq
            ) {
              is_exist = true;
              break;
            }
          }
          if (is_exist == false) {
            new_desku_arr.push(desk_use_info);
          }
        }
        room_info.desku_arr = new_desku_arr;
      }
      myProps.setRoomInfoArr(change_roomInfoArr);
    }
  };

  return (
    <>
      <CommonDataIo
        ref={myProps.data_io_ref}
        on_receive={on_receive}
      ></CommonDataIo>
    </>
  );
};
export default DataIo;